import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "../../../store/types/RootState";
import {getDefaultListSortOption, ListSortContext} from "../../sort/constants/create_list_sort_options";
import {IApplicationState} from "../types/IApplicationState";

export const applicationSlice = createSlice({
    name: "application",
    initialState: {
        listParams: {
            sort: getDefaultListSortOption(ListSortContext.APPLICATIONS)
        }
    } as IApplicationState,
    reducers: {
        setApplicationListParams: (state, action: PayloadAction<Partial<IApplicationState["listParams"]>>) => {
            state.listParams = {
                ...state.listParams,
                ...action.payload
            };
        }
    }
});

export const selectApplicationListParams = (state: RootState) => state.application.listParams;
export const {setApplicationListParams} = applicationSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "../../../store/types/RootState";
import {getDefaultListSortOption, ListSortContext} from "../../sort/constants/create_list_sort_options";
import {IApplicationState} from "../types/IApplicationState";

export const applicationSlice = createSlice({
    name: "application",
    initialState: {
        listParams: {
            sort: getDefaultListSortOption(ListSortContext.APPLICATIONS)
        }
    } as IApplicationState,
    reducers: {
        setApplicationListParams: (state, action: PayloadAction<Partial<IApplicationState["listParams"]>>) => {
            state.listParams = {
                ...state.listParams,
                ...action.payload
            };
        }
    }
});

export const selectApplicationListParams = (state: RootState) => state.application.listParams;
export const {setApplicationListParams} = applicationSlice.actions;
